<template>
    <DFormRow
        :label="__('customers.contracts.previous_contract_ids')"
        :error="errors.previous_contract_ids"
        :hint="hint ?? ''"
    >
        <div
            role="group"
            class="form-group"
        >
            <DMultiSelect
                id="previous_contract_ids"
                :options="previousContractOptionsArray"
                :search="true"
                :selection="true"
                options-empty-placeholder="No options placeholder"
                selection-type="tags"
                @update="previousContractIdChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    hint: {
        type: String,
        default: null
    },
    previousContractOptions: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['previousContractIdChanged', 'update:modelValue'])

const previousContractOptionsArray = computed(() => {
    return props.previousContractOptions.map((option) => ({ ...option, selected: props.modelValue.map(String).includes(String(option.value)) }))
})

function previousContractIdChanged (value) {
    emit('previousContractIdChanged', value)
}
</script>
